import type { ReadableError } from './types'

type ErrorTemplateProps = {
  resetErrorBoundary?: () => void
} & ReadableError

export const ErrorTemplate = ({
  title,
  description,
  code,
  resetErrorBoundary,
}: ErrorTemplateProps) => {
  const hasResetErrorBoundary = typeof resetErrorBoundary === 'function'

  return (
    <div className='flex flex-1 flex-col justify-center items-center px-4 sm:px-6 lg:px-8'>
      <div className='max-w-md w-full space-y-8 text-center'>
        <div className='mb-8'>
          {code && (
            <h2 className='mt-6 text-6xl font-extrabold text-foreground'>
              {code}
            </h2>
          )}
          <p className='mt-2 text-3xl font-bold text-foreground'>{title}</p>
          <p className='mt-2 text-sm text-muted-foreground'>{description}</p>
        </div>
        {hasResetErrorBoundary && (
          <div className='mt-8'>
            <button
              type='button'
              onClick={resetErrorBoundary}
              className='inline-flex items-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow-sm hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2'
            >
              Try again
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
